import { ComponentSlider } from '@emico-react/component-slider'
import { ReactNode, UIEventHandler } from 'react'

import { LastViewedProduct } from './LastViewedProduct'
import { RecentlyViewedProduct } from '../catalog/lastViewedProducts.query'
import { Responsive } from '../core/Responsive'

export type ArrowProps = {
    isDisabled: boolean
    handleClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

interface Props {
    slidesMobile?: number
    slidesDesktop?: number
    products: RecentlyViewedProduct[]
    onSlideChange?: (idx: number) => void
    onScroll?: UIEventHandler<HTMLDivElement>
}

export const LastViewedProducts = ({
    onSlideChange,
    onScroll,
    slidesDesktop = 6,
    slidesMobile = 4,
    products,
    ...other
}: Props & {
    prevArrow: (props: ArrowProps) => ReactNode
    nextArrow: (props: ArrowProps) => ReactNode
}) => {
    const slides = products?.map((prod, idx) => (
        <LastViewedProduct key={prod.id} productId={prod.id} index={idx} />
    ))

    return (
        <>
            <Responsive xs>
                <ComponentSlider slideGap={8}>
                    {slides?.slice(0, slidesMobile)}
                </ComponentSlider>
            </Responsive>

            <Responsive md up>
                <ComponentSlider
                    showArrows
                    slideGap={12}
                    renderPrevArrow={other.prevArrow}
                    renderNextArrow={other.nextArrow}
                >
                    {slides?.slice(0, slidesDesktop)}
                </ComponentSlider>
            </Responsive>
        </>
    )
}
